import { Directive, inject } from '@angular/core';

import { ApAlertService, ApComplexModal, ApNotificationService } from 'webcommon/core-ui';
import { FindControlAdditionalSearchParametersDto } from 'webcommon/shared';

import { FcFilterModalContext } from '../../models/index';

@Directive()
export abstract class FcFilterModalBaseComponent extends ApComplexModal<FindControlAdditionalSearchParametersDto> {
  protected readonly apNotificationService = inject(ApNotificationService);
  protected readonly alertService = inject(ApAlertService);

  public fcFilterModalContext: FcFilterModalContext;

  isLoading = false;
  isSaving = false;

  onClose(result: FindControlAdditionalSearchParametersDto) {
    this.apClose(result);
  }

  onCancel() {
    super.apUserCancel();
  }
}
